import { clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

// lib/theme-scale.ts
var THEME_SCALE_KEYS = {
  height: ["button-sm", "button-md", "button-lg", "input-sm", "input-md", "input-lg", "row-compact", "row-normal", "row-spacious", "icon-default"],
  minHeight: ["button-sm", "button-md", "button-lg", "input-sm", "input-md", "input-lg", "row-compact", "row-normal", "row-spacious"],
  width: ["icon-default"],
  fontSize: ["display-1", "display-2"],
  borderRadius: ["container", "interactive", "pill"],
  boxShadow: ["elevation-card", "elevation-popover", "elevation-dialog", "elevation-toast", "elevation-interactive", "elevation-pressed"],
  spacing: ["card-sm", "card-md", "card-lg", "dialog", "section"]
};

// lib/cn.ts
var scale = (keys) => [...keys];
var twMerge = extendTailwindMerge({
  extend: {
    theme: {
      spacing: scale(THEME_SCALE_KEYS.spacing),
      borderRadius: scale(THEME_SCALE_KEYS.borderRadius)
    },
    classGroups: {
      h: [{ h: scale(THEME_SCALE_KEYS.height) }],
      "min-h": [{ "min-h": scale(THEME_SCALE_KEYS.minHeight) }],
      w: [{ w: scale(THEME_SCALE_KEYS.width) }],
      "font-size": [{ text: scale(THEME_SCALE_KEYS.fontSize) }],
      shadow: [{ shadow: scale(THEME_SCALE_KEYS.boxShadow) }]
    }
  }
});
function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// lib/domPassthrough.ts
var GLOBAL_ATTRIBUTES = /* @__PURE__ */ new Set(["role", "id", "lang", "dir", "tabIndex"]);
function domPassthrough(props) {
  const out = {};
  for (const [key, value] of Object.entries(props)) {
    if (key.startsWith("aria-") || key.startsWith("data-") || GLOBAL_ATTRIBUTES.has(key)) {
      if (typeof value === "string" || typeof value === "number" || typeof value === "boolean" || value === void 0) {
        out[key] = value;
      }
    }
  }
  return out;
}

export { cn, domPassthrough };
